var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "el-section" }, [
    _c("div", { staticClass: "emd-container" }, [
      _c(
        "div",
        { staticClass: "emd-container__header eu-py_4_md eu-px_5_md" },
        [
          _c("h2", { staticClass: "emd-text _size_section _color_default" }, [
            _vm._v(" " + _vm._s(_vm.$t("title")) + " "),
          ]),
        ]
      ),
      _c("hr", { staticClass: "emd-divider" }),
      _c(
        "div",
        { staticClass: "emd-container__content eu-pa_5_md" },
        [
          _vm.showAlert
            ? _c(
                "emd-alert",
                {
                  attrs: { variant: "danger", title: _vm.$t("error.title") },
                  on: {
                    cancel: function ($event) {
                      _vm.showAlert = false
                    },
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "content" },
                    _vm._l(_vm.errors, function (error, index) {
                      return _c("p", {
                        key: index,
                        domProps: { innerHTML: _vm._s(error.message) },
                      })
                    }),
                    0
                  ),
                ],
                2
              )
            : _vm._e(),
          _c("div", { staticClass: "eu-flex" }, [
            _c(
              "section",
              {
                staticClass:
                  "el-chunk eu-flex-item eu-basis_4_lg eu-basis_6_md eu-basis_12",
              },
              [
                _c("div", { staticClass: "el-chunk" }, [
                  _c("h2", [
                    _c("strong", [_vm._v(_vm._s(_vm.$t("customer.client")))]),
                  ]),
                ]),
                _c("div", { staticClass: "el-chunk" }, [
                  _c("div", { staticClass: "el-grid-list _auto-fill" }, [
                    _c("div", { staticClass: "emd-container _type_card" }, [
                      _c("div", { staticClass: "emd-container__content" }, [
                        _c("div", { staticClass: "el-chunk" }, [
                          _c("h3", [
                            _vm._v(" " + _vm._s(_vm.customer.name) + " "),
                          ]),
                        ]),
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _size_small eu-text-overflow",
                          },
                          [_vm._v(_vm._s(_vm.customer.email))]
                        ),
                        _c("p", { staticClass: "emd-text _size_small" }, [
                          _vm._v(
                            _vm._s(_vm.formatDocument(_vm.customer.document))
                          ),
                        ]),
                        _vm.customer.mobile_phone.length
                          ? _c("p", { staticClass: "emd-text _size_small" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formatPhoneNumber(
                                    _vm.customer.mobile_phone
                                  )
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm.customer.home_phone.length
                          ? _c("p", { staticClass: "emd-text _size_small" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formatPhoneNumber(_vm.customer.home_phone)
                                )
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _vm.address.show_address
                      ? _c("div", { staticClass: "emd-container _type_card" }, [
                          _c("div", { staticClass: "emd-container__content" }, [
                            _c("div", { staticClass: "el-chunk" }, [
                              _c("h3", [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("customer.address")) + " "
                                ),
                              ]),
                            ]),
                            _c("p", { staticClass: "emd-text _size_small" }, [
                              _vm._v(
                                _vm._s(_vm.formatZipCode(_vm.address.zip_code))
                              ),
                            ]),
                            _c("p", { staticClass: "emd-text _size_small" }, [
                              _vm._v(
                                _vm._s(_vm.address.street) +
                                  ", " +
                                  _vm._s(_vm.address.number)
                              ),
                            ]),
                            _c("p", { staticClass: "emd-text _size_small" }, [
                              _vm._v(_vm._s(_vm.address.neighborhood)),
                            ]),
                            _c("p", { staticClass: "emd-text _size_small" }, [
                              _vm._v(
                                _vm._s(_vm.address.city) +
                                  " - " +
                                  _vm._s(_vm.address.state) +
                                  " - " +
                                  _vm._s(_vm.address.country)
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]
            ),
            _c(
              "section",
              {
                staticClass:
                  "el-chunk eu-flex-item eu-basis_4_lg eu-basis_6_md eu-basis_12",
              },
              [
                _c("div", { staticClass: "el-chunk" }, [
                  _c("h2", [
                    _c("strong", [_vm._v(_vm._s(_vm.$t("payment.method")))]),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "el-grid-list _auto-fill" },
                  [
                    _c("payment-details", {
                      attrs: {
                        "installment-value": _vm.calculateInstallmentValue,
                        "payment-method": _vm.selectedPaymentMethod,
                        "credit-card": _vm.credit_card,
                        checkout: _vm.checkout,
                        card: _vm.card,
                      },
                    }),
                    _vm.selectedPaymentMethod === "boleto"
                      ? _c("div", { staticClass: "emd-container _type_card" }, [
                          _c("div", { staticClass: "emd-container__content" }, [
                            _c("div", { staticClass: "el-chunk" }, [
                              _c("h3", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "payment." + _vm.selectedPaymentMethod
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                            ]),
                            _c("p", { staticClass: "emd-text _size_small" }, [
                              _vm._v(
                                "Válido até: " + _vm._s(_vm.payment.due_at)
                              ),
                            ]),
                            _c("p", { staticClass: "emd-text _size_small" }, [
                              _vm._v(
                                "Instruções: " +
                                  _vm._s(
                                    _vm.payment.instructions.length
                                      ? _vm.normalizeCharacteres(
                                          _vm.payment.instructions
                                        )
                                      : "-"
                                  )
                              ),
                            ]),
                            _c("p", { staticClass: "emd-text _size_small" }, [
                              _vm._v("Valor: " + _vm._s(_vm.totalAmount)),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    _vm.showBillingAddress &&
                    this.selectedPaymentMethod !== "pix"
                      ? _c("div", { staticClass: "emd-container _type_card" }, [
                          _c("div", { staticClass: "emd-container__content" }, [
                            _c("div", { staticClass: "el-chunk" }, [
                              _c("h3", [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("payment.address")) + " "
                                ),
                              ]),
                            ]),
                            _c("p", { staticClass: "emd-text _size_small" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formatZipCode(_vm.billingAddress.zip_code)
                                )
                              ),
                            ]),
                            _c("p", { staticClass: "emd-text _size_small" }, [
                              _vm._v(
                                _vm._s(_vm.billingAddress.street) +
                                  ", " +
                                  _vm._s(_vm.billingAddress.number)
                              ),
                            ]),
                            _c("p", { staticClass: "emd-text _size_small" }, [
                              _vm._v(_vm._s(_vm.billingAddress.neighborhood)),
                            ]),
                            _c("p", { staticClass: "emd-text _size_small" }, [
                              _vm._v(
                                _vm._s(_vm.billingAddress.city) +
                                  " - " +
                                  _vm._s(_vm.billingAddress.state) +
                                  " - " +
                                  _vm._s(_vm.billingAddress.country)
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
            _vm.selectedPaymentType === "items" ||
            _vm.selectedPaymentType === "typed-sale"
              ? _c(
                  "section",
                  {
                    staticClass:
                      "el-chunk eu-flex-item eu-basis_4_lg eu-basis_12",
                  },
                  [
                    _c("div", { staticClass: "el-chunk" }, [
                      _c("h2", [
                        _c("strong", [_vm._v(_vm._s(_vm.$t("items")))]),
                      ]),
                    ]),
                    _c("div", { staticClass: "el-grid-list _auto-fill" }, [
                      _c(
                        "div",
                        { staticClass: "el-chunk" },
                        [
                          _c(
                            "div",
                            { staticClass: "emd-container _type_card" },
                            [
                              _c(
                                "div",
                                { staticClass: "emd-container__content" },
                                [
                                  _c("table", { staticClass: "eu-width_100" }, [
                                    _c(
                                      "tbody",
                                      [
                                        _vm._l(
                                          _vm.items,
                                          function (item, index) {
                                            return _c("tr", { key: index }, [
                                              _c(
                                                "td",
                                                { staticClass: "eu-pb_1" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "emd-text _size_small",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.description
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "emd-badge _type_round",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "x" +
                                                          _vm._s(item.quantity)
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "eu-pb_1 emd-text _size_small _align_right",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.formatCurrency(
                                                          (_vm.formatToInt(
                                                            item.amount
                                                          ) *
                                                            item.quantity) /
                                                            100
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ])
                                          }
                                        ),
                                        _vm.formatToInt(_vm.shipping.amount)
                                          ? _c(
                                              "tr",
                                              { staticClass: "eu-border-top" },
                                              [
                                                _vm._m(0),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "emd-text _size_small _align_right",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.shipping.amount
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "tr",
                                          { staticClass: "eu-border-top" },
                                          [
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "emd-text _type_caption _size_small eu-pt_2",
                                              },
                                              [_vm._v(_vm._s(_vm.$t("total")))]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "emd-text _type_caption _align_right eu-pt_2",
                                              },
                                              [_vm._v(_vm._s(_vm.totalAmount))]
                                            ),
                                          ]
                                        ),
                                      ],
                                      2
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _c("order-code-details"),
                        ],
                        1
                      ),
                    ]),
                  ]
                )
              : _vm.selectedPaymentType !== "typed-sale"
              ? _c(
                  "section",
                  {
                    staticClass:
                      "el-chunk eu-flex-item eu-basis_4_lg eu-basis_12",
                  },
                  [
                    _c("div", { staticClass: "el-chunk" }, [
                      _c("p", [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.$t("subscription.title"))),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "el-chunk" }, [
                      _c("div", { staticClass: "el-grid-list _size_small" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "emd-container _type_card eu-height_100",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "emd-container__content" },
                              [
                                _c("div", { staticClass: "el-chunk" }, [
                                  _c("p", { staticClass: "emd-text" }, [
                                    _vm._v(_vm._s(_vm.items[0].description)),
                                  ]),
                                ]),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "emd-text _type_caption eu-pb_1",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "subscription.amount." +
                                            _vm.subscription.interval,
                                          {
                                            price: _vm.items[0].price,
                                            interval:
                                              _vm.subscription.interval_count,
                                          }
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm.items[0].cycle
                                  ? _c(
                                      "p",
                                      { staticClass: "emd-text _type_caption" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("subscription.interval", {
                                              cycle: _vm.items[0].cycle,
                                            })
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "p",
                                  { staticClass: "emd-text _type_caption" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("subscription.start", {
                                          start: _vm.subscription.start_at,
                                        })
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm.formatToInt(_vm.subscription.setup.amount)
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "emd-container _type_card eu-height_100",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "emd-container__content" },
                                  [
                                    _c("div", { staticClass: "el-chunk" }, [
                                      _c("h3", [
                                        _vm._v(
                                          _vm._s(_vm.$t("subscription.setup"))
                                        ),
                                      ]),
                                    ]),
                                    _c("div", { staticClass: "el-chunk" }, [
                                      _c("p", { staticClass: "emd-text" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.subscription.setup.description
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _c(
                                      "p",
                                      { staticClass: "emd-text _type_caption" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.subscription.setup.amount)
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "el-section" }, [
      _c(
        "div",
        {
          staticClass:
            "eu-display_flex eu-justify_space-between eu-wrap_reverse",
        },
        [
          _c(
            "button",
            {
              staticClass: "emd-btn _color_secondary _type_text _block_mobile",
              attrs: { disabled: _vm.loading },
              on: { click: _vm.reverseRoute },
            },
            [
              _c("i", { staticClass: "uil uil-angle-left" }),
              _vm._v(" " + _vm._s(_vm.$t("paymentData")) + " "),
            ]
          ),
          _c(
            "button",
            {
              staticClass:
                "emd-btn _color_secondary _block_mobile eu-mb_5 eu-no-margin_sm",
              attrs: { disabled: _vm.loading },
              on: { click: _vm.createOrder },
            },
            [
              _vm.loading
                ? _c("emd-loader")
                : _vm.selectedPaymentType === "subscription"
                ? _c("span", [
                    _vm._v(_vm._s(_vm.$t("finish." + _vm.selectedPaymentType))),
                  ])
                : _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("finish." + _vm.selectedPaymentMethod))
                    ),
                  ]),
            ],
            1
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "eu-py_2" }, [
      _c("span", { staticClass: "emd-text _size_small" }, [_vm._v(" Frete ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }